import { isNil, omitBy } from 'lodash';

import * as Models from 'contracts/models';

export const Endpoint = () => `/api/v4/catalog/versions/`;

export const QueryKey = (payload?: Payload) => ['v4', 'catalog', 'versions', omitBy(payload, isNil)] as const;

export type Payload = {
    vendor: string;
    product: string;
    year?: number;
    /** From 1 to 12 */
    month?: number;
    /** From 0 to 9 */
    score?: number;
    page?: number;
    size?: number;
    search?: string;
    sort?: {
        field: keyof Models.Catalog.Version.Item;
        direction: 'asc' | 'desc';
    };
};

export type Response = {
    total: number;
    items: Models.Catalog.Version.Item[];
};
